import PropTypes from 'prop-types';
import React from 'react';
import * as ResultUtils from '../utilities/results';
import Image from './Image';

class Result extends React.Component {
	constructor(props) {
		super(props);
		this.getStageRecommendations = ResultUtils.getStageRecommendations.bind(this);
		this.getContact = ResultUtils.getContact.bind(this);
	}

	getCircle = (viewBoxSize, className, size = '31.831') => {
		const spacer = (viewBoxSize - size) / 2;
		const half_the_size = size / 2;
		return (
			<path
				className={className}
				d={`M${half_the_size + spacer} ${spacer}a ${half_the_size} ${half_the_size} 0 0 1 0 ${size}a ${half_the_size} ${half_the_size} 0 0 1 0 -${size}`}
			/>
		);
	};

	getBulletPoints = (bullets) => {
		return Object.keys(bullets).map((key, index) => <li key={index}>{bullets[index].bullet}</li>);
	};

	render() {
		const viewBoxSize = 40;
		const { userData, image, labels } = this.props;
		const style = { '--percentage': `${userData.score}, 100` };

		const recommendations = this.getStageRecommendations();
		const contact = this.getContact();
		const expert_headline = labels[`expert_headline_${contact.gender}`];

		return (
			<div className="ms-form__result">
				<div className="ms-form__score" data-color-scheme="highlight">
					<div className="ms-form__percentage" style={style}>
						{image && <Image image={image} />}
						<svg className="value" viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
							{this.getCircle(viewBoxSize, 'circle-bg', 40)}
							{this.getCircle(viewBoxSize, 'circle-line')}
							{this.getCircle(viewBoxSize, 'circle')}
							<text className="text" x="50%" y="55%" dominantBaseline="middle" textAnchor="middle">
								{userData.score}
							</text>
						</svg>
					</div>
					{recommendations.intro && (
						<div className="ms-form__statement">
							<h4 className="text-subline">{recommendations.intro}</h4>
						</div>
					)}
				</div>
				{recommendations.text && (
					<div className="ms-form__recommendation">
						<h4 className="ms-form__expert-headline">{expert_headline}</h4>
						{contact.image && (
							<div className="ms-form__expert-image">
								<Image image={contact.image} />
							</div>
						)}
						<div className="ms-form__expert-text">
							<p dangerouslySetInnerHTML={{ __html: recommendations.text }} />
							{recommendations.bullet_points && <ul>{this.getBulletPoints(recommendations.bullet_points)}</ul>}
						</div>
						<div className="ms-form__expert-ending">
							<p>
								{labels.contact_greeting}
								<br />
								<strong>
									{contact.first_name} {contact.last_name}
								</strong>
							</p>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default Result;

Result.propTypes = {
	labels: PropTypes.object,
	image: PropTypes.any,
	highscoreContent: PropTypes.object,
	dimensions: PropTypes.object,
	userData: PropTypes.object,
	contacts: PropTypes.object,
	updateUserContact: PropTypes.func,
};
